import { Container } from "reactstrap";
import { BackLink, ToastContainer } from "../../components/Common";
import PocMapPage from "./page";

const PocMapPageWrapper = () => {
    return (
        <div className="page-content">
            <Container fluid>
                <BackLink />

                <PocMapPage />

            </Container>
            <ToastContainer />
        </div>
    );
};

export default PocMapPageWrapper;
